import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { useLayout } from '../../core'
import React, { MutableRefObject, useEffect, useRef } from 'react'
import { ToggleComponent } from '../../../assets/ts/components'
import { toAbsoluteUrl } from '../../../helpers/AssetHelpers'
import { KTIcon } from '../../../helpers/components/KTIcon'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { GetCompanyByIdResponse } from '../../../../models/response/company/GetCompanyByIdResponse'
import { storeActivityIndicator } from '../../../../redux/reducers/authSlice'
import { useDispatch } from 'react-redux'
import toast from "react-hot-toast";
import { CompanyService } from '../../../../services/CompanyService'

type PropsType = {
    sidebarRef: MutableRefObject<HTMLDivElement | null>
}

const SidebarLogo = (props: PropsType) => {
    const dispatch = useDispatch();
    const { config } = useLayout()
    const toggleRef = useRef<HTMLDivElement>(null)
    const auth = useSelector((state: RootState) => state.auth)

    const appSidebarDefaultMinimizeDesktopEnabled =
        config?.app?.sidebar?.default?.minimize?.desktop?.enabled
    const appSidebarDefaultCollapseDesktopEnabled =
        config?.app?.sidebar?.default?.collapse?.desktop?.enabled
    const toggleType = appSidebarDefaultCollapseDesktopEnabled
        ? 'collapse'
        : appSidebarDefaultMinimizeDesktopEnabled
            ? 'minimize'
            : ''
    const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
    const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default

    useEffect(() => {
        setTimeout(() => {
            const toggleObj = ToggleComponent.getInstance(toggleRef.current!) as ToggleComponent | null

            if (toggleObj === null) {
                return
            }

            // Add a class to prevent sidebar hover effect after toggle click
            toggleObj.on('kt.toggle.change', function () {
                // Set animation state
                props.sidebarRef.current!.classList.add('animating')

                // Wait till animation finishes
                setTimeout(function () {
                    // Remove animation state
                    props.sidebarRef.current!.classList.remove('animating')
                }, 300)
            })
        }, 600)
    }, [toggleRef, props.sidebarRef])

    const changeCompany = async (_companyId: string) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(_companyId);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            localStorage.setItem("SelectedCompanyId", response.data.companyId);
            localStorage.setItem("LastSelectedCompanyId", response.data.companyId);
            window.location.reload();
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            //
        }
    }

    return (
        <div className='app-sidebar-logo px-6' id='kt_app_sidebar_logo'>
            <React.Fragment>
                {config.layoutType === 'dark-sidebar' ? (
                    <div className='app-sidebar-logo-default'>
                        <div data-kt-menu-trigger='click' data-kt-menu-placement='bottom-start' className='actionIcon d-flex'>
                            <div className='d-flex'>
                                <img
                                    style={{ minWidth: 50, minHeight: 50, width: 50, height: 50 }}
                                    alt='Logo'
                                    src={auth.selectedCompany?.logo}
                                    className='img img-thumbnail app-sidebar-logo-default'
                                />
                            </div>
                            <div style={{ marginLeft: 10 }} className='d-flex align-items-center flex-grow-1'>
                                <h6 className='text-white mb-0'>{auth.selectedCompany?.name}</h6>
                            </div>
                        </div>

                        <div className='menu menu-sub menu-sub-dropdown min-w-200px mt-3' data-kt-menu='true'>
                            {
                                auth.companyList.map((item, index) =>
                                    <div onClick={() => changeCompany(item.companyId)} style={{ borderTop: index > 0 ? '1px solid #f1f1f4' : undefined }} className='actionIcon p-3 d-flex'>
                                        <div className='d-flex'>
                                            <img
                                                style={{ width: 50, height: 50 }}
                                                alt='Logo'
                                                src={item.logo}
                                                className='img img-thumbnail app-sidebar-logo-default'
                                            />
                                        </div>
                                        <div style={{ marginLeft: 10 }} className='d-flex align-items-center flex-grow-1'>
                                            <h6 className='text-black mb-0'>{item.name}</h6>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                ) : (
                    <>
                        <img
                            alt='Logo'
                            src={toAbsoluteUrl('media/logos/default.svg')}
                            className='h-25px app-sidebar-logo-default theme-light-show'
                        />
                        <img
                            alt='Logo'
                            src={toAbsoluteUrl('media/logos/default-dark.svg')}
                            className='h-25px app-sidebar-logo-default theme-dark-show'
                        />
                    </>
                )}

                <img
                    style={{ width: 25, height: 25 }}
                    alt='Logo'
                    src={auth.selectedCompany?.logo}
                    className='img img-thumbnail app-sidebar-logo-minimize'
                />
            </React.Fragment>

            {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && (
                <div
                    ref={toggleRef}
                    id='kt_app_sidebar_toggle'
                    className={clsx(
                        'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
                        { active: appSidebarDefaultMinimizeDefault }
                    )}
                    data-kt-toggle='true'
                    data-kt-toggle-state={toggleState}
                    data-kt-toggle-target='body'
                    data-kt-toggle-name={`app-sidebar-${toggleType}`}
                >
                    <KTIcon iconName='black-left-line' className='fs-3 rotate-180 ms-1' />
                </div>
            )}
        </div>
    )
}

export { SidebarLogo }
